import { createContext } from 'react';

const ReducerContext = createContext();
// export const ReducerContextProvider = ReducerContext.Provider;
export default ReducerContext;